import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable.jsx";
import { Spin, Select } from "antd";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_LEAVE_SUMMARY,
} from "../RollCallConfig/RollCallConfig.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../core/common/footer/commonFooter.jsx";
import FallBackMessage from "../RollCallConfig/FallBackMessage.jsx";

const LeaveSummary = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

  const [leaveSummary, setLeaveSummary] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [loading, setloading] = useState(false);

  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;
    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];

    if (!perms) {
      navigate(`/${userData?.DefaultPath}`);
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);
  const regId = userData?.RegId;
  console.log(regId);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchSummary = () => {
    if (tokenData && superIdData) {
      setloading(true);

      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_LEAVE_SUMMARY}?regid=${regId}&year=${selectedYear}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok)
            throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data?.status) {
            setLeaveSummary(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setLeaveSummary([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  };
  console.log(leaveSummary);

  useEffect(() => {
    fetchSummary(); // Initial fetch
  }, [superIdData, tokenData]);

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "LvCode",
      sorter: (a, b) => a.LvCode.length - b.LvCode.length,
      render: (text) => {
        const badgeMap = {
          CT: { color: "primary", label: "Casual" },
          PL: { color: "success", label: "Personal" },
          SL: { color: "danger", label: "Sick" },
          OD: { color: "warning", label: "On Duty" },
          WO: { color: "info", label: "Week Off" },
          OL: { color: "secondary", label: "Optional" },
          CO: { color: "dark", label: "Comp Off" },
          EL: { color: "primary", label: "Earned" },
          HL: { color: "light", label: "Holiday" },
        };

        const badge = badgeMap[text] || { color: "dark", label: text };

        return <span className={`badge bg-${badge.color}`}>{badge.label}</span>;
      },
    },
    {
      title: "Carry Forward",
      dataIndex: "CarryForwardLeaves",
      sorter: (a, b) =>
        a.CarryForwardLeaves.length - b.CarryForwardLeaves.length,
    },
    {
      title: "Accrued",
      dataIndex: "Accrued",
      sorter: (a, b) => a.Accrued.length - b.Accrued.length,
    },
    {
      title: "Taken",
      dataIndex: "Taken",
      sorter: (a, b) => a.Taken.length - b.Taken.length,
    },
    {
      title: "Accrued",
      dataIndex: "Balance",
      sorter: (a, b) => a.Balance.length - b.Balance.length,
    },
  ];

  const generatePDF = () => {
    if (leaveSummary && leaveSummary.length === 0) {
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const getLeaveTypeLabel = (code) => {
      const badgeMap = {
        CT: "Casual",
        PL: "Personal",
        SL: "Sick",
        OD: "On Duty",
        WO: "Week Off",
        OL: "Optional",
        CO: "Comp Off",
        EL: "Earned",
        HL: "Holiday",
      };
      return badgeMap[code] || code || "N/A";
    };

    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return "Pending";
        case 2:
          return "Approved";
        case 3:
          return "Rejected";
        default:
          return "N/A";
      }
    };

    const doc = new jsPDF();
    doc.text("leaveSummary Report", 14, 10);

    const tableColumn = [
      "Start Date",
      "End Date",
      "Leave Type",
      "Count",
      "Reason",
      "Status",
    ];

    const tableRows = leaveSummary.map((item) => [
      formatDate(item.StartDt),
      formatDate(item.EndDt),
      getLeaveTypeLabel(item.LvCode),
      item.LeaveCount ?? "N/A",
      item.Total_Hours || item.Reason || "N/A",
      getStatusLabel(item.status),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("leaveSummary_Report.pdf");
  };

  const handleDownloadExcel = () => {
    if (leaveSummary && leaveSummary.length === 0) {
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const getLeaveTypeLabel = (code) => {
      const badgeMap = {
        CT: "Casual",
        PL: "Personal",
        SL: "Sick",
        OD: "On Duty",
        WO: "Week Off",
        OL: "Optional",
        CO: "Comp Off",
        EL: "Earned",
        HL: "Holiday",
      };
      return badgeMap[code] || code || "N/A";
    };

    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return "Pending";
        case 2:
          return "Approved";
        case 3:
          return "Rejected";
        default:
          return "N/A";
      }
    };

    const wsData = leaveSummary.map((item, index) => ({
      "S.No": index + 1,
      "Start Date": formatDate(item.StartDt),
      "End Date": formatDate(item.EndDt),
      "Leave Type": getLeaveTypeLabel(item.LvCode),
      Count: item.LeaveCount ?? "N/A",
      Reason: item.Total_Hours || item.Reason || "N/A",
      Status: getStatusLabel(item.status),
      Comments: item.Comments || "N/A",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "leaveSummary Report");
    XLSX.writeFile(wb, "leaveSummary_Report.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={`/${userData?.DefaultPath}`}>
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Leave Summary
                    </h4>
                  </ol>
                </nav>
                <h6>Track It, Plan It, Take It – With Leave Summary.</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li onClick={() => window.location.reload()}>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderRefreshTooltip}
                    >
                      <Link data-bs-toggle="tooltip" data-bs-placement="top">
                        <RotateCcw />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
            </ul>
          </div>
          {/* /product list */}
          {perm?.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-2">
                    <Select
                      value={selectedYear}
                      style={{ width: 100 }}
                      onChange={(value) => setSelectedYear(value)}
                    >
                      {years.map((year) => (
                        <Select.Option key={year} value={year}>
                          {year}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  <div className="me-2"></div>
                  <div>
                    <button className="btn btn-primary" onClick={fetchSummary}>
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : leaveSummary.length > 0 ? (
                    <Table columns={columns} dataSource={leaveSummary} />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <FallBackMessage />
          )}
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default LeaveSummary;
